// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="video.VideoCountTotalChart"></bfg-chart>
    </div>
</div>

<installs-table rows="rows" prec="0"></installs-table>
`;
// Exports
module.exports = code;